import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { callIfChanged } from 'utilities/forms';

import { generateDistributionData } from 'store/scenes/distributions/actions';
import { getDistributionsFormValues } from 'store/form/distributions/selectors';

import DistributionTypeDropdownComponent from './Component';

const options = [
  {
    value: 'normal',
    label: 'Normal Distribution',
    text: 'Normal Distribution'
  },
  {
    value: 'binomial',
    text: 'Binomial Distribution'
  },
  {
    value: 'student',
    label: 'T Distribution',
    text: 'T Distribution'
  },
  {
    value: 'fisher',
    label: 'F Distribution',
    text: 'F Distribution'
  },
  {
    value: 'chisquare',
    label: 'Chi Square Distribution',
    text: 'Chi Square Distribution'
  }
];

class DistributionTypeDropdownContainer extends React.PureComponent {
  static propTypes = {
    generateDistributionData: PropTypes.func.isRequired
  }

  constructor (props) {
    super(props);

    this.handleChange = callIfChanged((_, newDistributionType) => {
      this.props.generateDistributionData(newDistributionType);
    });
  }

  render () {
    return (
      <DistributionTypeDropdownComponent
        onChange={this.handleChange}
        options={options}
      />
    );
  }
}

const mapDispatchToProps = {
  generateDistributionData: newDistributionType => (dispatch, getState) => {
    const distributionFormValues = getDistributionsFormValues(getState());

    dispatch(
      generateDistributionData({
        ...distributionFormValues,
        type: newDistributionType
      })
    );
  }
};

export default connect(null, mapDispatchToProps)(
  DistributionTypeDropdownContainer
);
